export const openWindow = (
  url: string,
  target: '_blank' | '_self' | '_parent' | '_top' | string = '_blank',
  features: string = 'noopener,noreferrer'
) => {
  const w = window.open(url, target, features);

  if (w) {
    w.opener = null;
  }
};
